/**
 * Template: Blog
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled code used on the Blog template.
 *
 * @namespace blog
 */
import BlogCategories from '../components/blog-categories';
import BlogArticleGrid from '../components/blog-article-grid';
document.addEventListener('DOMContentLoaded', () => {
  BlogCategories().init();
  BlogArticleGrid().init();
});